module finadai.app.negotiations.list {
  export var NAME = 'finadai.negotiations.list';
  function NegotiationsListController($scope, negotiationsService: services.NegotiationsService, agents, $filter) {
    $scope.agents = agents.data.data;
    $scope.filters = { with: 'credits,customer,agent,meta,payment_type'};
        
    $scope.query = {
        order: '-created_at._date',
        limit: 10,
        page: 1
    };
    $scope.reload = () => {
      $scope.promise = negotiationsService.get(null, angular.copy($scope.filters)).then(response => {
        $scope.negotiations = response.data;
        return response;
      });
    }
    $scope.download = () => {
      negotiationsService.download($scope.filters).then(response => {
        if(response.status == 200){
          window.location = response.data.url;
        }
      });
    }
    $scope.$watchCollection('filters', function (newNames, oldNames) {
      $scope.reload();
    });
  }
  export function run() {
    var list = angular.module(NAME, []);
    list.controller('NegotiationsListController', NegotiationsListController);
  }
} finadai.app.negotiations.list.run();